/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { ApplicationError } from '../model/application-error.model';
import { MessageFactory, MessageFactoryProvider } from '../provider/message-factory.provider';
import { TextService } from '../service/text.service';

export class ApplicationErrorMessageFactory implements MessageFactory {

  constructor(protected textService: TextService) { }

  getMessage(error: ApplicationError): string {
    const keyMessageFactory = MessageFactoryProvider.resolveMessageFactory(error.key);
    if (keyMessageFactory) {
      return keyMessageFactory.getMessage(error);
    }
    const messageArgs = this.getMessageArguments(error);
    return this.textService.getText(error.key, messageArgs);
  }

  getMessageArguments(error: ApplicationError): object {
    const messageArgs = {};
    if (error.arguments) {
      Object.keys(error.arguments).forEach((key: string) => {
        messageArgs[key] = this.getMessageArgument(error.arguments[key]);
      });
    }
    return messageArgs;
  }

  getMessageArgument(argument: any): any {
    if (!argument || typeof argument !== 'object') {
      return argument;
    }
    if (Array.isArray(argument)) {
      return argument.map((argumentItem: any) => this.getMessageArgument(argumentItem));
    }
    const argumentMessageFactory = MessageFactoryProvider.resolveMessageFactory(argument);
    if (argumentMessageFactory) {
      return argumentMessageFactory.getMessage(argument);
    }
    if (argument instanceof Error) {
      return argument.message;
    }
    return argument;
  }
}
